import { makeAutoObservable } from 'mobx';

export class AppStore {
  width = 1024;

  height = 768;

  blackoutBg = false;

  locationHistory = {
    from: '',
    to: '',
  };

  constructor() {
    makeAutoObservable(this);
  }

  setLocation = (path: string): void => {
    this.locationHistory = { from: this.locationHistory.to, to: path };
  };

  setDimension = ({ width, height }: { width: number; height: number }): void => {
    this.width = width;
    this.height = height;
  };

  setBlackoutBg = (value: boolean): void => {
    this.blackoutBg = value;
  };
}

export const appStore = new AppStore();
